import { z } from 'zod';

/** Period (YYYY-MM) and staff type live in the URL for every staff commission screen. */
export const staffSearchSchema = z.object({
  period: z
    .string()
    .regex(/^\d{4}-(0[1-9]|1[0-2])$/)
    .optional()
    .catch(undefined),
  staffType: z.enum(['employee', 'outsourced']).optional().catch(undefined),
});

/**
 * Paths of the staff commission area someone who sees only their own commission may open: the My commission page and
 * their own statements. Everything else (statements list, adjustments, clawbacks, rules, payout runs) sends them back
 * to My commission, so old bookmarks keep working.
 */
export function isMyCommissionPath(pathname: string, userId: string): boolean {
  const p = pathname.replace(/\/+$/, '');
  return p === '/staff-commission' || p.startsWith(`/staff-commission/statements/${userId}/`);
}
